var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnarchiveWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-548.461 333.847-402.308 376-360.155l74.001-74.001v178.001h59.998v-178.001L584-360.155l42.153-42.153L480-548.461Zm-280-95.385v431.537q0 5.385 3.462 8.847 3.462 3.462 8.847 3.462h535.382q5.385 0 8.847-3.462 3.462-3.462 3.462-8.847v-431.537H200Zm15.386 503.845q-29.923 0-52.654-22.731-22.731-22.731-22.731-52.654v-464.382q0-12.846 4.116-24.5 4.115-11.653 12.346-21.499l56.154-67.924q9.846-12.846 24.615-19.577 14.769-6.731 31.231-6.731h422.305q16.461 0 31.423 6.731 14.961 6.731 24.807 19.577l56.539 68.693q8.231 9.846 12.346 21.692 4.116 11.846 4.116 24.692v463.228q0 29.923-22.731 52.654-22.731 22.731-52.654 22.731H215.386Zm.229-563.844H744l-43.616-51.924q-1.923-1.923-4.423-3.077Q693.46-760 690.768-760h-421.92q-2.693 0-5.193 1.154-2.5 1.154-4.424 3.077l-43.616 51.924ZM480-421.923Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchiveWhite);
export default __webpack_public_path__ + "static/media/unarchive-white.df02707130ed5a7cc50a36c1c5438914.svg";
export { ForwardRef as ReactComponent };